export enum OfferPrimaryCoverageCode {
    OC = 'OC',
    NNW = 'NNW',
    ASSISTANCE = 'ASSISTANCE',
    AC = 'AC',
    AC_MINI = 'AC_MINI'
}
